/**
 * Tizim bo'ylab umumiy holatlar va sanoqlar.
 * Qiymatlar Prisma enum'lari bilan bir xil bo'lishi shart (apps/api/prisma/schema.prisma).
 */
/** Muddatli to'lov provayderlari (BT §2). */
export const Provider = {
    ALIF: 'ALIF',
    UZUM: 'UZUM',
};
export const PROVIDERS = [Provider.ALIF, Provider.UZUM];
/** Foydalanuvchi ekranida ko'rinadigan nomlar. */
export const PROVIDER_LABELS = {
    [Provider.ALIF]: 'Alif Nasiya',
    [Provider.UZUM]: 'Uzum Nasiya',
};
/** Adapter rejimi: kalitlar kelmaguncha `mock` bilan ishlaymiz (BT §10). */
export const AdapterMode = {
    MOCK: 'mock',
    REAL: 'real',
};
/**
 * Bitta provayder natijasining holati (BT §6.5).
 *
 *   PENDING → IN_PROGRESS → APPROVED → CHOSEN → CONTRACT_ACTIVE
 *                         → REJECTED
 *                         → TIMEOUT
 *   APPROVED (tanlanmagan) → NOT_CHOSEN
 */
export const ProviderResultStatus = {
    PENDING: 'PENDING',
    IN_PROGRESS: 'IN_PROGRESS',
    /**
     * Provayder mijozdan SMS kodini kutmoqda.
     *
     * BT §6.5 da bunday holat yo'q edi — «bitta tugma → natija» deb
     * hisoblangan. Amalda esa yangi mijoz uchun Alif ham, Uzum ham
     * scoring o'rtasida kartani tasdiqlashni so'raydi va kod
     * kiritilmaguncha limit hisoblanmaydi (dev'da tekshirilgan).
     *
     * Bu holatda oqim to'xtaydi, lekin IKKINCHI provayder mustaqil
     * davom etadi — parallellik buzilmaydi.
     */
    AWAITING_OTP: 'AWAITING_OTP',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
    TIMEOUT: 'TIMEOUT',
    CHOSEN: 'CHOSEN',
    NOT_CHOSEN: 'NOT_CHOSEN',
    CONTRACT_ACTIVE: 'CONTRACT_ACTIVE',
};
/** Yakuniy (o'zgarmaydigan) holatlar. */
export const TERMINAL_RESULT_STATUSES = [
    ProviderResultStatus.REJECTED,
    ProviderResultStatus.TIMEOUT,
    ProviderResultStatus.NOT_CHOSEN,
    ProviderResultStatus.CONTRACT_ACTIVE,
];
/** Ruxsat etilgan o'tishlar — state machine shu jadval bo'yicha tekshiriladi. */
export const RESULT_TRANSITIONS = {
    PENDING: [
        ProviderResultStatus.IN_PROGRESS,
        ProviderResultStatus.REJECTED,
        ProviderResultStatus.TIMEOUT,
    ],
    IN_PROGRESS: [
        ProviderResultStatus.AWAITING_OTP,
        ProviderResultStatus.APPROVED,
        ProviderResultStatus.REJECTED,
        ProviderResultStatus.TIMEOUT,
    ],
    // Kod tasdiqlangach yana hisoblashga qaytamiz. Kod kelmasa yoki
    // urinishlar tugasa — TIMEOUT/REJECTED. Mijoz shu orada ikkinchi
    // provayderni tanlasa — NOT_CHOSEN: kodni kiritishning ma'nosi qolmaydi.
    AWAITING_OTP: [
        ProviderResultStatus.IN_PROGRESS,
        ProviderResultStatus.REJECTED,
        ProviderResultStatus.TIMEOUT,
        ProviderResultStatus.NOT_CHOSEN,
    ],
    APPROVED: [ProviderResultStatus.CHOSEN, ProviderResultStatus.NOT_CHOSEN],
    CHOSEN: [ProviderResultStatus.CONTRACT_ACTIVE, ProviderResultStatus.NOT_CHOSEN],
    REJECTED: [],
    TIMEOUT: [],
    NOT_CHOSEN: [],
    CONTRACT_ACTIVE: [],
};
export function canTransition(from, to) {
    return RESULT_TRANSITIONS[from].includes(to);
}
export function isTerminalStatus(status) {
    return TERMINAL_RESULT_STATUSES.includes(status);
}
/** Faqat APPROVED natijani tanlash mumkin (BT §7.4, §9). */
export function isSelectable(status) {
    return status === ProviderResultStatus.APPROVED;
}
/** Provayder mijozdan ma'lumot kutyaptimi — ekranda forma ko'rsatiladi. */
export function isAwaitingInput(status) {
    return status === ProviderResultStatus.AWAITING_OTP;
}
/**
 * Scoring hali tugamaganmi.
 * `AWAITING_OTP` ham tugamagan hisoblanadi: kod kiritilsa davom etadi.
 */
export function isPendingStatus(status) {
    return (status === ProviderResultStatus.PENDING ||
        status === ProviderResultStatus.IN_PROGRESS ||
        status === ProviderResultStatus.AWAITING_OTP);
}
/** Butun scoring so'rovining umumiy holati. */
export const ScoringRequestStatus = {
    PENDING: 'PENDING',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    CHOSEN: 'CHOSEN',
    FAILED: 'FAILED',
};
/** Ariza (application) holati. */
export const ApplicationStatus = {
    DRAFT: 'DRAFT',
    OTP_PENDING: 'OTP_PENDING',
    CONFIRMED: 'CONFIRMED',
    CONTRACT_CREATED: 'CONTRACT_CREATED',
    CANCELLED: 'CANCELLED',
    FAILED: 'FAILED',
};
/** Shartnoma holati. */
export const ContractStatus = {
    DRAFT: 'DRAFT',
    ACTIVE: 'ACTIVE',
    CANCELLED: 'CANCELLED',
};
/** OTP nima uchun yuborilgani — qaysi OTP qaysi provayderga tegishli (BT §6.2). */
export const OtpPurpose = {
    /** Alif: kartani biriktirish */
    CARD_ATTACH: 'CARD_ATTACH',
    /** Uzum: oferta bilan rozilik */
    ACCEPTANCE: 'ACCEPTANCE',
    /** Uzum: kartani tasdiqlash */
    CARD_CONFIRM: 'CARD_CONFIRM',
    /** Alif: rassrochkani rasmiylashtirish */
    INSTALLMENT: 'INSTALLMENT',
};
export const OtpStatus = {
    PENDING: 'PENDING',
    CONFIRMED: 'CONFIRMED',
    EXPIRED: 'EXPIRED',
    FAILED: 'FAILED',
};
/** Rollar (BT §3). */
export const UserRole = {
    SALES: 'SALES',
    ADMIN: 'ADMIN',
};
//# sourceMappingURL=enums.js.map